import { useState } from "react";

export const useCancelModal = () => {
  const [openCancelModal, setOpenCancelModal] = useState(false);

  const handleOpenCancelModal = () => {
    setOpenCancelModal(true);
  };

  const handleCloseCancelModal = () => {
    setOpenCancelModal(false);
  };

  return { openCancelModal, handleOpenCancelModal, handleCloseCancelModal };
};
